module.exports = __webpack_public_path__ + "static/mary-ocarroll-7400755d844b6c4cbbf4c7fe31101a28.png";